import { Injectable } from '@angular/core';

import { CookieService } from 'ngx-cookie-service';

import { AbstractService } from '../abstract-service';
import { SessionStorageService } from '../web-storage';

@Injectable({
  providedIn: "root"
})
export class AppSessionCheckService extends AbstractService {
  protected sessionStorageKey = "globalSessionId";
  private referenceGlobalSessionId = "X-PruGlobalSessionID";

  constructor(
    private cookieService: CookieService,
    protected sessionStorageService: SessionStorageService
  ) {
    super();
  }

  handleApplicationSessionIntegrity(dataKeysToRemove: Array<string>): void {
    const activeSessionId = this.cookieService.get(
      this.referenceGlobalSessionId
    );

    if (!!activeSessionId) {
      const currentSessionId = this.getDataFromSessionStorage(
        false
      );

      if (activeSessionId !== currentSessionId) {
        this.removeSessionData(dataKeysToRemove);

        this.setDataToSessionStorage(activeSessionId, false);
      }
    }
  }

  private removeSessionData(keys: Array<string>): void {
    if (!keys || keys.length === 0) {
      return;
    }

    keys.forEach(key => this.sessionStorageService.removeItem(key));
  }
}
